/**
 * K9 Vitality — Sticky Selector v4: Minimal + Expand
 * Thin bar + bottom sheet (mobile) | Dropdowns (desktop)
 * Direct DOM listeners only (no PUB_SUB_EVENTS — AVADA breaks them).
 */
(function () {
  'use strict';

  function init(sid) {
    var bar = document.getElementById('kv-sticky-' + sid);
    if (!bar || bar.dataset.kvStickyInit) return;
    bar.dataset.kvStickyInit = '1';

    var dataEl = document.getElementById('kv-sticky-data-' + sid);
    if (!dataEl) return;
    var D;
    try { D = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var mode = D.mode;
    function fmt(p) { return '\u20B9' + Math.round(p / 100).toLocaleString('en-IN'); }

    function resolveVid(label) {
      if (!label) return null;
      var vm = D.variantMap || {};
      var lc = label.toLowerCase().trim();
      if (vm[label] !== undefined) return vm[label];
      for (var k in vm) { if (k.toLowerCase().trim() === lc) return vm[k]; }
      for (var k2 in vm) { if (k2.toLowerCase().indexOf(lc) !== -1) return vm[k2]; }
      var num = lc.replace(/g$/, '').trim();
      for (var k3 in vm) { var kl = k3.toLowerCase(); if (kl.indexOf(num + ' gram') !== -1 || kl.indexOf(num + 'g') !== -1) return vm[k3]; }
      return null;
    }

    // ─── Visibility ───
    (function () {
      // revealAbove (TOF landers): keep the bar visible on every section EXCEPT the buy
      // box itself — show it above (hero) and below (proof/reviews), hide only while the
      // buy box is on screen. PDP renders omit reveal_above, so their behaviour is unchanged
      // (bar appears only after the buy area scrolls above the viewport).
      var revealAbove = D.revealAbove === true;
      var target = null;
      if (revealAbove) target = document.getElementById('MainProduct-' + sid);
      if (!target) {
        if (mode === 'weight-plan') {
          target = document.querySelector('[data-kv-wps="' + sid + '"]') || document.querySelector('[data-kv-wps]');
        } else {
          target = document.querySelector('.product-form__buttons') || document.querySelector('[type="submit"][name="add"]');
        }
      }
      if (!target) target = document.querySelector('.product__info-wrapper') || document.querySelector('[id^="MainProduct-"]');
      if (!target) return;
      function reveal() { bar.removeAttribute('hidden'); bar.offsetHeight; bar.classList.add('kv-sticky--visible'); }
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) bar.classList.remove('kv-sticky--visible');
          else if (revealAbove || e.boundingClientRect.top < 0) reveal();
        });
      }, { threshold: 0 }).observe(target);
    })();

    // ═══ WEIGHT-PLAN MODE ═══
    if (mode === 'weight-plan') {
      var pm = D.priceMap || {}, cpm = D.compareAtPriceMap || {}, pc = D.planConfig || {};
      // Subscribe discount % by plan. MUST match the main selector (kv-weight-plan-selector.js).
      var subPct = D.subDiscountPct || {};
      // mode mirrors the main buy box's subscribe/one-time choice. The bar must never
      // quote a subscribe price while the box is set to one-time, or the customer sees
      // the number drop when they scroll up to pay.
      var st = { weight: null, plan: null, mode: 'subscribe' };
      var wL = { '4-11': '4-11 kg', '12-26': '12-26 kg', '27-45': '27-45 kg', '46+': '46+ kg' };
      var pL = { '30': '30 Day', '60': '60 Day', '90': '90 Day' };

      // DOM refs — mobile bar
      var ctaBtn  = document.getElementById('kv-sticky-cta-' + sid);
      var selBar  = document.getElementById('kv-sticky-selbar-' + sid);
      var swEl    = document.getElementById('kv-sticky-sw-' + sid);
      var spEl    = document.getElementById('kv-sticky-sp-' + sid);
      var spackEl = document.getElementById('kv-sticky-spack-' + sid);
      var changeBtn = document.getElementById('kv-sticky-change-' + sid);
      var priceEl = document.getElementById('kv-sticky-price-' + sid);
      var cmpEl   = document.getElementById('kv-sticky-cmp-' + sid);
      var savEl   = document.getElementById('kv-sticky-sav-' + sid);
      var atcEl   = document.getElementById('kv-sticky-atc-' + sid);

      // DOM refs — bottom sheet
      var backdrop = document.getElementById('kv-sticky-backdrop-' + sid);
      var sheet    = document.getElementById('kv-sticky-sheet-' + sid);
      var closeBtn = document.getElementById('kv-sticky-close-' + sid);
      var sheetPlanSec = document.getElementById('kv-sticky-sheet-plan-' + sid);
      var sheetPack = document.getElementById('kv-sticky-sheet-pack-' + sid);
      var sheetPrices = document.getElementById('kv-sticky-sheet-prices-' + sid);
      var sheetPrice = document.getElementById('kv-sticky-sheet-price-' + sid);
      var sheetCmp = document.getElementById('kv-sticky-sheet-cmp-' + sid);
      var sheetSav = document.getElementById('kv-sticky-sheet-sav-' + sid);
      var sheetAtc = document.getElementById('kv-sticky-sheet-atc-' + sid);

      // DOM refs — desktop
      var dw = document.getElementById('kv-sticky-dw-' + sid);
      var dp = document.getElementById('kv-sticky-dp-' + sid);
      var dpackEl = document.getElementById('kv-sticky-dpack-' + sid);
      var dpriceEl = document.getElementById('kv-sticky-dprice-' + sid);
      var dcmpEl = document.getElementById('kv-sticky-dcmp-' + sid);
      var dsavEl = document.getElementById('kv-sticky-dsav-' + sid);
      var datcEl = document.getElementById('kv-sticky-datc-' + sid);

      // DOM refs — subscribe / one-time switch (desktop bar, mobile bar, sheet)
      var modeWraps = ['d', 'm', 's']
        .map(function (slot) { return document.getElementById('kv-sticky-mode-' + slot + '-' + sid); })
        .filter(Boolean);

      function mainRoot() {
        return document.querySelector('[data-kv-wps="' + sid + '"]') || document.querySelector('[data-kv-wps]');
      }
      function modeBtns() {
        var out = [];
        modeWraps.forEach(function (w) {
          w.querySelectorAll('[data-sticky-buymode]').forEach(function (b) { out.push(b); });
        });
        return out;
      }
      // The bar hands off to the main box, so its CTA must say the same thing the box
      // will say — 'Start my plan' subscribes, 'Add to Cart' does not.
      function ctaLabel() { return st.mode === 'onetime' ? 'Add to Cart' : 'Start my plan'; }
      function updateCtaLabels() {
        var l = ctaLabel();
        if (atcEl) atcEl.textContent = l;
        if (sheetAtc) sheetAtc.textContent = l;
        if (datcEl && !datcEl.disabled) datcEl.textContent = l;
      }
      function updateModeUI() {
        var want = st.mode === 'onetime' ? 'onetime' : 'subscribe';
        modeBtns().forEach(function (b) {
          var on = b.dataset.stickyBuymode === want;
          b.classList.toggle('kv-sticky__mode-btn--active', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        var pct = subPct[st.plan] || 0;
        modeWraps.forEach(function (w) {
          w.querySelectorAll('[data-sticky-subpct]').forEach(function (s) {
            s.textContent = pct ? pct + '%' : '';
          });
        });
        updateCtaLabels();
      }

      function packText() {
        if (!st.weight || !st.plan) return '';
        var cfg = pc[st.weight] && pc[st.weight][st.plan];
        if (!cfg) return '';
        return 'Includes: ' + cfg.items.map(function (i) { return i.qty + '\u00d7 ' + i.title; }).join(' + ');
      }

      function calcPrice() {
        if (!st.weight || !st.plan) return { price: 0, compare: 0 };
        var cfg = pc[st.weight] && pc[st.weight][st.plan];
        if (!cfg) return { price: 0, compare: 0 };
        var tp = 0, tc = 0;
        cfg.items.forEach(function (it) {
          var vid = resolveVid(it.title);
          if (vid) { var vs = String(vid); tp += (pm[vs] || pm[vid] || 0) * it.qty; tc += (cpm[vs] || cpm[vid] || 0) * it.qty; }
        });
        return { price: tp, compare: tc };
      }

      // Show the SUBSCRIBE price (matches the main buy box, which is the source of
      // truth). Strike-through = the one-time price, so the number never appears to
      // jump UP when the customer scrolls from the box to the bar.
      function updateAllPrices() {
        var p = calcPrice();
        var oneTime = p.price;
        var pct = subPct[st.plan] || 0;
        var subPrice = pct ? Math.round(oneTime * (1 - pct / 100)) : oneTime;
        // One-time mode shows the plain one-time price with no strike-through: the box
        // will not apply a subscribe discount, so advertising one here would be a lie.
        var subscribing = st.mode !== 'onetime';
        var shown = subscribing ? subPrice : oneTime;
        var hasSave = subscribing && subPrice < oneTime;
        var savAmt = oneTime - subPrice;
        var showSav = hasSave && savAmt >= 10000;

        // Mobile bar
        if (priceEl) priceEl.textContent = fmt(shown);
        if (cmpEl) { cmpEl.textContent = fmt(oneTime); cmpEl.hidden = !hasSave; }
        if (savEl) { savEl.textContent = 'Save ' + fmt(savAmt); savEl.hidden = !showSav; }

        // Sheet
        if (sheetPrice) sheetPrice.textContent = fmt(shown);
        if (sheetCmp) { sheetCmp.textContent = fmt(oneTime); sheetCmp.hidden = !hasSave; }
        if (sheetSav) { sheetSav.textContent = 'Save ' + fmt(savAmt); sheetSav.hidden = !showSav; }
        if (sheetPrices) sheetPrices.hidden = false;
        if (sheetAtc) sheetAtc.hidden = false;

        // Desktop
        if (dpriceEl) dpriceEl.textContent = fmt(shown);
        if (dcmpEl) { dcmpEl.textContent = fmt(oneTime); dcmpEl.hidden = !hasSave; }
        if (dsavEl) { dsavEl.textContent = 'Save ' + fmt(savAmt); dsavEl.hidden = !showSav; }

        // Pack text
        var pt = packText();
        if (spackEl) spackEl.textContent = pt.replace('Includes: ', '');
        if (sheetPack) { sheetPack.textContent = pt; sheetPack.hidden = !pt; }
        if (dpackEl) { dpackEl.textContent = pt ? '📦 ' + pt.replace('Includes: ', '') : ''; dpackEl.hidden = !pt; }

        // keeps the discount badge honest when the plan changes (15% vs 20%)
        updateModeUI();
      }

      function updateBarState() {
        if (st.weight && st.plan) {
          if (ctaBtn) ctaBtn.hidden = true;
          if (selBar) selBar.hidden = false;
          if (swEl) swEl.textContent = wL[st.weight] || st.weight;
          if (spEl) spEl.textContent = pL[st.plan] || st.plan;
          updateAllPrices();
        } else {
          if (ctaBtn) ctaBtn.hidden = false;
          if (selBar) selBar.hidden = true;
        }
      }

      // ─── Sheet open/close ───
      function openSheet() {
        if (!backdrop || !sheet) return;
        backdrop.classList.add('kv-sticky__backdrop--open');
        sheet.classList.add('kv-sticky__sheet--open');
        document.body.style.overflow = 'hidden';
      }
      function closeSheet() {
        if (!backdrop || !sheet) return;
        backdrop.classList.remove('kv-sticky__backdrop--open');
        sheet.classList.remove('kv-sticky__sheet--open');
        document.body.style.overflow = '';
      }

      if (ctaBtn) ctaBtn.addEventListener('click', openSheet);
      if (changeBtn) changeBtn.addEventListener('click', openSheet);
      if (closeBtn) closeBtn.addEventListener('click', closeSheet);
      if (backdrop) backdrop.addEventListener('click', closeSheet);

      // ─── Sheet weight pills ───
      var sheetWPills = sheet ? sheet.querySelectorAll('[data-sheet-weight]') : [];
      sheetWPills.forEach(function (b) {
        b.addEventListener('click', function () {
          st.weight = this.dataset.sheetWeight;
          st.plan = null;
          sheetWPills.forEach(function (p) { p.classList.toggle('kv-sticky__sheet-pill--active', p.dataset.sheetWeight === st.weight); });
          // Show plan section, clear plan
          if (sheetPlanSec) sheetPlanSec.hidden = false;
          var sheetPPills = sheet.querySelectorAll('[data-sheet-plan]');
          sheetPPills.forEach(function (p) { p.classList.remove('kv-sticky__sheet-pill--active'); });
          if (sheetPrices) sheetPrices.hidden = true;
          if (sheetAtc) sheetAtc.hidden = true;
          if (sheetPack) sheetPack.hidden = true;
          // Sync desktop dropdown
          if (dw) dw.value = st.weight;
          if (dp) { dp.value = ''; dp.disabled = false; }
          syncToMain('weight', st.weight);
        });
      });

      // ─── Sheet plan pills ───
      var sheetPPills = sheet ? sheet.querySelectorAll('[data-sheet-plan]') : [];
      sheetPPills.forEach(function (b) {
        b.addEventListener('click', function () {
          st.plan = this.dataset.sheetPlan;
          sheetPPills.forEach(function (p) { p.classList.toggle('kv-sticky__sheet-pill--active', p.dataset.sheetPlan === st.plan); });
          updateAllPrices();
          updateBarState();
          // Sync desktop
          if (dp) dp.value = st.plan;
          syncToMain('plan', st.plan);
        });
      });

      // Sheet ATC
      if (sheetAtc) sheetAtc.addEventListener('click', function () { doAddToCart(sheetAtc); });

      // ─── Desktop dropdowns ───
      function updateDesktopAtcState() {
        if (!datcEl) return;
        if (st.weight && st.plan) {
          datcEl.disabled = false;
          datcEl.classList.remove('kv-sticky__desk-atc--disabled');
          datcEl.textContent = ctaLabel();
        } else {
          datcEl.disabled = true;
          datcEl.classList.add('kv-sticky__desk-atc--disabled');
          datcEl.textContent = !st.weight ? 'Select Weight & Plan' : 'Select Plan';
        }
      }

      if (dw) dw.addEventListener('change', function () {
        st.weight = this.value;
        st.plan = null;
        if (dp) { dp.value = ''; dp.disabled = false; }
        if (dpackEl) dpackEl.hidden = true;
        if (dpriceEl) dpriceEl.textContent = '';
        if (dcmpEl) dcmpEl.hidden = true;
        if (dsavEl) dsavEl.hidden = true;
        // Sync sheet
        sheetWPills.forEach(function (p) { p.classList.toggle('kv-sticky__sheet-pill--active', p.dataset.sheetWeight === st.weight); });
        if (sheetPlanSec) sheetPlanSec.hidden = false;
        sheetPPills.forEach(function (p) { p.classList.remove('kv-sticky__sheet-pill--active'); });
        updateBarState();
        updateDesktopAtcState();
        syncToMain('weight', st.weight);
      });

      if (dp) dp.addEventListener('change', function () {
        st.plan = this.value;
        updateAllPrices();
        updateBarState();
        updateDesktopAtcState();
        // Sync sheet
        sheetPPills.forEach(function (p) { p.classList.toggle('kv-sticky__sheet-pill--active', p.dataset.sheetPlan === st.plan); });
        syncToMain('plan', st.plan);
      });

      // Desktop ATC
      if (datcEl) datcEl.addEventListener('click', function () { doAddToCart(datcEl); });
      // Mobile bar ATC
      if (atcEl) atcEl.addEventListener('click', function () { doAddToCart(atcEl); });

      // ─── Subscribe / one-time switch ───
      // Only offered when the main buy box actually has the choice; on any page whose
      // box has no subscribe option the switch stays hidden rather than promising one.
      (function () {
        var root = mainRoot();
        if (!root || !root.querySelector('[data-buy-mode]')) {
          // No subscribe option on this product. Leave the switch hidden and make sure the
          // bar's CTA matches the box instead of inheriting the subscribe wording.
          st.mode = 'onetime';
          updateCtaLabels();
          return;
        }
        modeWraps.forEach(function (w) { w.hidden = false; });
        var live = root.querySelector('[data-buy-mode][aria-pressed="true"]');
        if (live) st.mode = live.dataset.buyMode;
        updateModeUI();

        modeBtns().forEach(function (b) {
          b.addEventListener('click', function () {
            var m = b.dataset.stickyBuymode;
            if (st.mode === m) return;
            st.mode = m;
            updateModeUI();
            updateAllPrices();
            var target = root.querySelector('[data-buy-mode="' + m + '"]');
            if (target && target.getAttribute('aria-pressed') !== 'true') target.click();
          });
        });

        // and follow the box when the customer changes it there instead
        root.querySelectorAll('[data-buy-mode]').forEach(function (b) {
          b.addEventListener('click', function () {
            var m = this.dataset.buyMode;
            if (st.mode === m) return;
            st.mode = m;
            updateModeUI();
            updateAllPrices();
          });
        });
      })();

      // ─── ATC handler ───
      // On the subscribe PDP the MAIN buy box owns price, discount, free jerky, and
      // the subscribe-vs-one-time choice. The sticky only mirrors weight+plan into
      // the box (via syncToMain) and then sends the customer there to complete.
      // It must NEVER fire a one-time /cart/add: doing so charged 60/90-day at the
      // FULL one-time price and silently bypassed the subscription entirely.
      function doAddToCart(btn) {
        if (!st.weight || !st.plan) return;
        closeSheet();
        var main = document.querySelector('[data-kv-wps="' + sid + '"]') || document.querySelector('[data-kv-wps]');
        if (main) main.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }

      // ─── Sync to main selector ───
      function syncToMain(type, val) {
        var root = document.querySelector('[data-kv-wps="' + sid + '"]') || document.querySelector('[data-kv-wps]');
        if (!root) return;
        var sel = type === 'weight' ? '[data-weight-btn="' + val + '"]' : '[data-plan-btn="' + val + '"]';
        var btn = root.querySelector(sel);
        if (btn && btn.getAttribute('aria-pressed') !== 'true') btn.click();
      }

      // ─── Sync FROM main on load + clicks ───
      (function () {
        var root = document.querySelector('[data-kv-wps="' + sid + '"]') || document.querySelector('[data-kv-wps]');
        if (!root) return;
        root.querySelectorAll('[data-weight-btn]').forEach(function (b) {
          b.addEventListener('click', function () {
            var w = this.dataset.weightBtn;
            if (st.weight !== w) {
              st.weight = w; st.plan = null;
              sheetWPills.forEach(function (p) { p.classList.toggle('kv-sticky__sheet-pill--active', p.dataset.sheetWeight === w); });
              if (sheetPlanSec) sheetPlanSec.hidden = false;
              sheetPPills.forEach(function (p) { p.classList.remove('kv-sticky__sheet-pill--active'); });
              if (dw) dw.value = w;
              if (dp) { dp.value = ''; dp.disabled = false; }
              updateBarState();
              updateDesktopAtcState();
            }
          });
        });
        root.querySelectorAll('[data-plan-btn]').forEach(function (b) {
          b.addEventListener('click', function () {
            var p = this.dataset.planBtn;
            if (st.plan !== p) {
              st.plan = p;
              sheetPPills.forEach(function (pill) { pill.classList.toggle('kv-sticky__sheet-pill--active', pill.dataset.sheetPlan === p); });
              if (dp) dp.value = p;
              updateAllPrices();
              updateBarState();
              updateDesktopAtcState();
            }
          });
        });
        // Initial state
        var aw = root.querySelector('[data-weight-btn][aria-pressed="true"]');
        if (aw) {
          st.weight = aw.dataset.weightBtn;
          sheetWPills.forEach(function (p) { p.classList.toggle('kv-sticky__sheet-pill--active', p.dataset.sheetWeight === st.weight); });
          if (sheetPlanSec) sheetPlanSec.hidden = false;
          if (dw) dw.value = st.weight;
          var ap = root.querySelector('[data-plan-btn][aria-pressed="true"]');
          if (ap) {
            st.plan = ap.dataset.planBtn;
            sheetPPills.forEach(function (pill) { pill.classList.toggle('kv-sticky__sheet-pill--active', pill.dataset.sheetPlan === st.plan); });
            if (dp) { dp.value = st.plan; dp.disabled = false; }
            updateAllPrices();
          }
          updateBarState();
          updateDesktopAtcState();
        }
      })();

    // ═══ STANDARD MODE ═══
    } else {
      var variants = D.variants || [];
      var selId = null;
      var ap = bar.querySelector('.kv-sticky__std-pill--active');
      if (ap) selId = parseInt(ap.dataset.stickyVariant);
      // A single-variant product renders no pills, so there is no active chip to
      // read the id from. Without this the ATC handler returns on !selId and the
      // button silently does nothing.
      if (!selId && variants.length === 1) selId = variants[0].id;

      var priceEl = document.getElementById('kv-sticky-price-' + sid);
      var cmpEl = document.getElementById('kv-sticky-cmp-' + sid);
      var savEl = document.getElementById('kv-sticky-sav-' + sid);
      var atcEl = document.getElementById('kv-sticky-atc-' + sid);

      bar.querySelectorAll('[data-sticky-variant]').forEach(function (b) {
        b.addEventListener('click', function () {
          var vid = parseInt(this.dataset.stickyVariant);
          selId = vid;
          bar.querySelectorAll('[data-sticky-variant]').forEach(function (p) { p.classList.toggle('kv-sticky__std-pill--active', parseInt(p.dataset.stickyVariant) === vid); });
          var v = variants.find(function (vr) { return vr.id === vid; });
          if (v) {
            if (priceEl) priceEl.textContent = fmt(v.price);
            if (cmpEl) { cmpEl.textContent = fmt(v.compareAtPrice); cmpEl.hidden = !(v.compareAtPrice > v.price); }
            if (savEl) { var s = v.compareAtPrice - v.price; if (s >= 10000) { savEl.textContent = 'Save ' + fmt(s); savEl.hidden = false; } else savEl.hidden = true; }
          }
          var mi = document.querySelector('input[type="radio"][value="' + vid + '"]');
          if (mi && !mi.checked) { mi.click(); return; }
          var sw = document.querySelector('[data-variant-id="' + vid + '"]'); if (sw) sw.click();
        });
      });

      if (atcEl) atcEl.addEventListener('click', function () {
        if (!selId) return;
        var mf = document.querySelector('#product-form-' + sid) || document.querySelector('product-form form');
        if (mf) { var ii = mf.querySelector('input[name="id"]'); if (ii) ii.value = selId; var sb = mf.querySelector('[type="submit"]'); if (sb && sb.getAttribute('aria-disabled') !== 'true') sb.click(); }
      });
    }
  }

  function boot() { document.querySelectorAll('[data-kv-sticky]').forEach(function (s) { init(s.dataset.kvSticky); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { init(e.detail.sectionId); });
})();
